import React, { useState, useRef, useCallback, useEffect } from "react";
import { FaLevelUpAlt, FaLevelDownAlt } from "react-icons/fa";
import { showToast } from "../../utils/utils";
import { Link, useParams, useNavigate } from "react-router-dom";
import { fontSize, fontWeight } from "../../utils/data/data";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import Logo from "../../assets/images/logo.png";
import Select from "react-select";
import "./emailtemplate.scss";
import {
  DASH_LOWERCASE_REGEX,
  showToastType
} from "../../utils/constants/appConstants";
import {
  alertActions,
  commonErrMsg,
  editEmailTemp,
  emailTemplate
} from "../../locales/en";
import { getEmailTemplateByIdThunk } from "../../redux/emailTemplate.slice";
import { useDispatch } from "react-redux";
import {
  fetchemailTemplateURL,
  getEmailIdActiveURL,
  getFindByUserAccountIdsURL
} from "../../utils/constants/apiEndPoints";
import privateAxios from "../../utils/axiosPrivate";
import { sanitizeInput } from "../../utils/utils";
import {
  editTextAlign,
  getButtonTypeOptions,
  getEmailElementOptions
} from "../../utils/getDropdownOptions";
import { EMAIL_TEMPLATES } from "../../route/paths";

const EditMailTemplate = () => {
  const { id } = useParams();
  const initialRender = useRef(true);
  const navigate = useNavigate();
  const [emailContentData, setEmailContentData] = useState([]);
  const [elements, setElements] = useState([]);
  const initialEmailData = {
    templateName: "",
    emailSubject: "",
    triggerDescription: "",
    senderEmail: "",
    senderName: "",
    replyToEmail: "",
    newElement: "",
    paraDescription: "",
    fontWeight: "400",
    fontSize: "16px",
    btnUrl: "",
    btnText: "",
    btnType: "No",
    linkUrl: "",
    linkText: "",
    textAlign: "left",
    emailContent: []
  };
  const [emailData, setEmailData] = useState(initialEmailData);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingType, setEditingType] = useState(null);
  const [emailIds, setEmailIds] = useState([]);
  const [defaultCC, setDefaultCC] = useState(new Set());
  const [showReplyToField, setShowReplyToField] = useState(false);

  const dispatch = useDispatch();

  const fetchEmailTemplate = async () => {
    try {
      const response = await dispatch(getEmailTemplateByIdThunk(id)).unwrap();

      const templateData = response.data.data;
      setElements(templateData);

      setEmailData((prevData) => ({
        ...prevData,
        templateName: templateData.templateName,
        emailSubject: templateData.emailSubject,
        triggerDescription: templateData.triggerDescription,
        senderEmail: templateData.senderEmail,
        senderName: templateData.senderName,
        replyToEmail: templateData.replyToEmail || ""
      }));

      setEmailContentData(response.data.data.emailContent);
      const matchedEmails = templateData?.ccEmailAddresses;
      setDefaultCC(new Set(matchedEmails));
      setShowReplyToField(
        templateData.replyToEmail !== null &&
          templateData.replyToEmail !== undefined &&
          templateData.replyToEmail !== ""
      );

      return templateData;
    } catch {
      // handle catch here;
    }
  };

  const fetchEmailIds = useCallback(async (ccEmailAddresses = []) => {
    try {
      if (Array.isArray(ccEmailAddresses) && ccEmailAddresses.length > 0) {
        const userAccountResponse = await privateAxios.get(
          getFindByUserAccountIdsURL(ccEmailAddresses)
        );

        const userAccountData = (userAccountResponse.data.data || []).map(
          (user) => ({
            value: user.id,
            label: `${user.displayName} -- (${user.primaryEmail})`
          })
        );

        setEmailIds(userAccountData);
      }

      const emailResponse = await privateAxios.get(getEmailIdActiveURL);
      const fullEmailData = (emailResponse.data.data || []).map((user) => ({
        value: user.id,
        label: `${user.displayName} -- (${user.primaryEmail})`
      }));

      setEmailIds(fullEmailData);
    } catch (error) {
      if (error?.response && error.response.status === 404) {
        // Handle 404 case
      } else {
        showToast(error?.response?.data?.message, showToastType.error);
      }
    }
  }, []);

  const getNextId = () => {
    if (!emailContentData || emailContentData.length === 0) {
      return "para_1";
    }

    const lastItem = emailContentData[emailContentData.length - 1];

    if (!lastItem || !lastItem.id || !lastItem.id.includes("_")) {
      return "para_1";
    }

    const idParts = lastItem.id.split("_");
    const idNumber = parseInt(idParts[1], 10);

    return isNaN(idNumber) ? "para_1" : `para_${idNumber + 1}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setEmailData((prevState) => ({
      ...prevState,
      [name]: sanitizeInput(value)
    }));

    if (name === "newElement" && editingIndex === null) {
      const newId = getNextId();
      const newElement = {
        id: newId,
        content: sanitizeInput(emailData.paraDescription),
        dataType: value,
        style: {
          textAlign: emailData.textAlign,
          fontWeight: emailData.fontWeight,
          fontSize: emailData.fontSize
        },
        btnText:
          value === "button" ? sanitizeInput(emailData.btnText) : undefined,
        btnUrl:
          value === "button" ? sanitizeInput(emailData.btnUrl) : undefined,
        linkText:
          value === "link" ? sanitizeInput(emailData.linkText) : undefined,
        linkUrl: value === "link" ? sanitizeInput(emailData.linkUrl) : undefined
      };

      setEmailContentData((prevData) => [...prevData, newElement]);
      setEditingIndex(emailContentData.length);
    }

    if (editingIndex !== null) {
      setEmailContentData((prevData) =>
        prevData.map((item, index) =>
          index === editingIndex
            ? {
                ...item,
                ...(name === "paraDescription" && {
                  content: sanitizeInput(value)
                }),
                ...(name === "btnText" && { btnText: sanitizeInput(value) }),
                ...(name === "linkText" && { linkText: sanitizeInput(value) }),
                ...(name === "hrLine"),
                ...(["btnUrl", "btnType", "linkUrl"].includes(name) && {
                  [name]: sanitizeInput(value)
                }),
                ...(["textAlign", "fontWeight", "fontSize"].includes(name) && {
                  style: {
                    ...item.style,
                    [name]: sanitizeInput(value)
                  }
                })
              }
            : item
        )
      );
    }
  };

  const handleDeleteElement = (index) => {
    setEmailContentData((prevData) => prevData.filter((_, i) => i !== index));
    clearForm();
  };

  const handleSubmit = async () => {
    try {
      const updatedEmailTemplate = {
        emailContent: emailContentData.map((content) => ({
          ...content,
          style: {
            textAlign: content.style?.textAlign || "left",
            fontWeight: content.style?.fontWeight || "400",
            fontSize: content.style?.fontSize || "14px"
          }
        })),
        isAdminTemplate: false
      };

      const response = await privateAxios.put(
        fetchemailTemplateURL(id),
        updatedEmailTemplate
      );

      showToast(response.data.message, showToastType.success);
    } catch (error) {
      const errorMessage = error.response?.data?.message || commonErrMsg.item4;
      showToast(errorMessage, showToastType.error);
    }
  };

  const handleBlur = async (e) => {
    const { name, value } = e.target;

    setEmailData((prevState) => ({
      ...prevState,
      [name]: sanitizeInput(value)
    }));

    try {
      const updatedEmailTemplate = {
        templateName: sanitizeInput(emailData.templateName),
        emailSubject: sanitizeInput(emailData.emailSubject),
        triggerDescription: sanitizeInput(emailData.triggerDescription),
        isAdminTemplate: false,
        senderEmail: sanitizeInput(emailData.senderEmail),
        senderName: sanitizeInput(emailData.senderName),
        replyToEmail: sanitizeInput(emailData.replyToEmail)
      };

      const response = await privateAxios.put(
        fetchemailTemplateURL(id),
        updatedEmailTemplate
      );

      showToast(response.data.message, showToastType.success);
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors[0] || commonErrMsg.item4;
      showToast(errorMessage, showToastType.error);
    }
  };

  const handleMoveElement = (index, direction) => {
    if (index === null || index < 0 || index >= emailContentData.length) return;

    const updatedElements = [...emailContentData];
    const [movedElement] = updatedElements.splice(index, 1);

    if (direction === "up" && index > 0) {
      updatedElements.splice(index - 1, 0, movedElement);
      setEditingIndex(index - 1);
    } else if (direction === "down" && index < updatedElements.length) {
      updatedElements.splice(index + 1, 0, movedElement);
      setEditingIndex(index + 1);
    }

    setEmailContentData(updatedElements);
  };

  const clearForm = () => {
    setEmailData({
      ...emailData,
      paraDescription: "",
      fontWeight: "400",
      fontSize: "16px",
      btnUrl: "",
      btnText: "",
      linkUrl: "",
      linkText: "",
      newElement: "",
      textAlign: "left",
      replyToEmail: emailData.replyToEmail
    });
    setEditingIndex(null);
    setEditingType(null);
  };

  const handleElementClick = (
    id,
    content,
    style,
    elementType,
    btnText = "",
    btnUrl = "",
    linkText = "",
    linkUrl = ""
  ) => {
    const toCamelCase = (str) =>
      String(str)
        .trim()
        .replace(DASH_LOWERCASE_REGEX, (_, c) => c.toUpperCase());

    let styleObject = {};
    if (typeof style === "string") {
      styleObject = Object.fromEntries(
        style
          .split(";")
          .filter(Boolean)
          .map((s) => {
            const [key, value] = s.split(":").map((part) => part.trim());
            return [toCamelCase(key), value];
          })
      );
    } else if (style && typeof style === "object") {
      styleObject = Object.fromEntries(
        Object.entries(style).map(([key, value]) => [toCamelCase(key), value])
      );
    } else {
      styleObject = {};
    }

    const index = emailContentData.findIndex((item) => item.id === id);

    setEditingIndex(index);
    setEditingType(elementType);

    if (elementType === "paragraph") {
      setEmailData((prevState) => ({
        ...prevState,
        newElement: "paragraph",
        paraDescription: content || "",
        textAlign: styleObject?.textAlign || "left",
        fontWeight: styleObject?.fontWeight || "400",
        fontSize: styleObject?.fontSize || "14px"
      }));
    } else if (elementType === "button") {
      setEmailData((prevState) => ({
        ...prevState,
        newElement: "button",
        btnText: btnText || "",
        btnUrl: btnUrl || "",
        textAlign: styleObject?.textAlign || "left",
        fontWeight: styleObject?.fontWeight || "400",
        fontSize: styleObject?.fontSize || "14px"
      }));
    } else if (elementType === "link") {
      setEmailData((prevState) => ({
        ...prevState,
        newElement: "link",
        linkText: linkText || "",
        linkUrl: linkUrl || "",
        textAlign: styleObject?.textAlign || "left",
        fontWeight: styleObject?.fontWeight || "400",
        fontSize: styleObject?.fontSize || "14px"
      }));
    } else if (elementType === "hrLine") {
      setEmailData((prevState) => ({
        ...prevState,
        newElement: "hrLine"
      }));
    }
  };
  useEffect(() => {
    if (initialRender.current) {
      fetchEmailTemplate().then((templateData) => {
        const ccList = templateData?.ccEmailAddresses || [];
        fetchEmailIds(ccList);
      });

      initialRender.current = false;
    }

    const getYearElement = document.getElementById("getYear");
    if (getYearElement) {
      const currentYear = new Date().getFullYear();
      getYearElement.textContent = currentYear;
    }
  }, [fetchEmailIds, id]);

  const handleSelectChange = async (selectedOptions) => {
    setDefaultCC(
      new Set((selectedOptions || []).map((option) => option.value))
    );

    try {
      const updatedEmailTemplate = {
        isAdminTemplate: false,
        ccEmailAddresses: selectedOptions.map((item) => item.value)
      };

      // Send the updated data to the backend
      const response = await privateAxios.put(
        fetchemailTemplateURL(id),
        updatedEmailTemplate
      );

      showToast(response.data.message, showToastType.success);
    } catch (error) {
      const errorMessage = error.response?.data?.message || commonErrMsg.item4;
      showToast(errorMessage, showToastType.error);
    }
  };

  const handleCancel = () => {
    navigate(EMAIL_TEMPLATES);
  };

  return (
    <>
      <TablePagesTitle
        mainTitle={emailTemplate.mainTitle}
        content={editEmailTemp.content}
      />
      <AccessPageAction
        subheading={`Edit Template - "${elements.templateName}"`}
      />
      <div className="row mt-3">
        <div className="col-md-4 col-lg-3 border-end">
          <div className="dynamic-content-section mb-3">
            <label htmlFor="dymicContent">
              <strong>{editEmailTemp.dymicContent}</strong>
            </label>
            <div className="mt-2">
              <ul className="ms-5 template-list">
                {elements.shortCodes?.map((shortCode, index) => (
                  <li key={index}>{shortCode}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="templateName">
              <strong>{editEmailTemp.templateName}</strong>
            </label>
            <input
              type="text"
              placeholder="Please enter email template name"
              name="templateName"
              value={emailData.templateName}
              onChange={handleInputChange}
              onBlur={handleBlur}
            />
          </div>
          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="subject">
              <strong>{editEmailTemp.subject}</strong>
            </label>
            <input
              type="text"
              placeholder="Please enter email subject"
              name="emailSubject"
              value={emailData.emailSubject}
              onChange={handleInputChange}
              onBlur={handleBlur}
            />
          </div>
          <div className="input-group-wrap mb-2">
            <label className="mb-1" htmlFor="triggerDescription">
              <strong>{editEmailTemp.triggerDescription}</strong>
            </label>
            <textarea
              name="triggerDescription"
              placeholder="Please enter trigger description"
              value={emailData.triggerDescription}
              onChange={handleInputChange}
              className="email-description-field"
              onBlur={handleBlur}
            />
          </div>
          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="fromEmail">
              <strong>{editEmailTemp.fromEmail}</strong>
            </label>
            <input
              type="email"
              placeholder="Please enter from email address"
              name="senderEmail"
              value={emailData.senderEmail}
              onChange={handleInputChange}
              onBlur={handleBlur}
            />
          </div>
          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="fromName">
              <strong>{editEmailTemp.fromName}</strong>
            </label>
            <input
              type="text"
              placeholder="Please enter from name"
              name="senderName"
              value={emailData.senderName}
              onChange={handleInputChange}
              onBlur={handleBlur}
            />
          </div>
          {showReplyToField && (
            <div className="input-group-wrap mb-3">
              <label className="mb-1" htmlFor="to">
                <strong>{editEmailTemp.to}</strong>
              </label>
              <input
                type="email"
                placeholder="Please enter email"
                name="replyToEmail"
                value={emailData.replyToEmail}
                onChange={handleInputChange}
                onBlur={handleBlur}
              />
            </div>
          )}

          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="cc">
              <strong>{editEmailTemp.cc}</strong>
            </label>
            <Select
              isMulti
              name="emailIds"
              value={emailIds.filter((item) => defaultCC.has(item.value))}
              options={emailIds}
              onChange={handleSelectChange}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="addElement">
              <strong>{editEmailTemp.addElement}</strong>
            </label>
            <select
              name="newElement"
              id="newElement"
              value={emailData.newElement}
              onChange={handleInputChange}
            >
              {getEmailElementOptions().map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {emailData.newElement === "paragraph" && (
            <div className="mail-content">
              <div className="input-group-wrap mb-2">
                <label className="mb-1" htmlFor="contentText">
                  <strong>{editEmailTemp.contentText}</strong>
                </label>
                <textarea
                  name="paraDescription"
                  placeholder="Please enter the content"
                  value={emailData.paraDescription}
                  onChange={handleInputChange}
                />
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="textAlignment">
                  <strong>{editEmailTemp.textAlignment}</strong>
                </label>
                <select
                  name="textAlign"
                  id="textAlign"
                  value={emailData.textAlign}
                  onChange={handleInputChange}
                >
                  {editTextAlign?.map((item, index) => (
                    <option value={item.value} key={index}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="fontWeight">
                  <strong>{editEmailTemp.fontWeight}</strong>
                </label>
                <select
                  name="fontWeight"
                  id="fontWeight"
                  value={emailData.fontWeight}
                  onChange={handleInputChange}
                >
                  {fontWeight.map((data, index) => (
                    <option key={index} value={data.value}>
                      {data.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="fontSize">
                  <strong>{editEmailTemp.fontSize}</strong>
                </label>
                <select
                  name="fontSize"
                  id="fontSize"
                  value={emailData.fontSize}
                  onChange={handleInputChange}
                >
                  {fontSize.map((data, index) => (
                    <option key={index} value={data.value}>
                      {data.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group-wrap mb-3 d-flex justify-content-between align-content-center">
                <button
                  type="button"
                  className="btn btn-primary up"
                  onClick={() => handleMoveElement(editingIndex, "up")}
                  disabled={editingIndex === null || editingIndex === 0}
                >
                  <FaLevelUpAlt />
                </button>
                <button
                  type="button"
                  className="btn btn-primary down"
                  onClick={() => handleMoveElement(editingIndex, "down")}
                  disabled={
                    editingIndex === null ||
                    editingIndex === emailContentData.length - 1
                  }
                >
                  <FaLevelDownAlt />
                </button>
              </div>

              <div className="input-group-wrap mb-3">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={() => handleSubmit("paragraph")}
                >
                  {editingIndex !== null && editingType === "paragraph"
                    ? editEmailTemp.updateParagraph
                    : editEmailTemp.addParagraph}
                </button>
              </div>
              {editingIndex !== null && (
                <div
                  className="input-group-wrap mb-3"
                  onClick={() => handleDeleteElement(editingIndex)}
                >
                  <button type="button" className="btn btn-secondary btn-block">
                    {editEmailTemp.deleteParagraph}
                  </button>
                </div>
              )}
            </div>
          )}

          {emailData.newElement === "button" && (
            <div className="mail-content">
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="buttonLink">
                  <strong>{editEmailTemp.buttonLink}</strong>
                </label>
                <input
                  type="text"
                  placeholder="Please enter button URL"
                  name="btnUrl"
                  value={emailData.btnUrl}
                  onChange={handleInputChange}
                />
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="buttonText">
                  <strong>{editEmailTemp.buttonText}</strong>
                </label>
                <input
                  type="text"
                  placeholder="Please enter button text"
                  name="btnText"
                  value={emailData.btnText || ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="fullWidthButton">
                  <strong>{editEmailTemp.fullWidthButton}</strong>
                </label>
                <select
                  name="btnType"
                  id="btnType"
                  value={emailData.btnType}
                  onChange={handleInputChange}
                >
                  {getButtonTypeOptions().map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="textAlignment">
                  <strong>{editEmailTemp.textAlignment}</strong>
                </label>
                <select
                  name="textAlign"
                  id="buttonTextAlign"
                  value={emailData.textAlign}
                  onChange={handleInputChange}
                >
                  {editTextAlign?.map((item, index) => (
                    <option value={item.value} key={index}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group-wrap mb-3 d-flex justify-content-between align-content-center">
                <button
                  type="button"
                  className="btn btn-primary up"
                  onClick={() => handleMoveElement(editingIndex, "up")}
                  disabled={editingIndex === null || editingIndex === 0}
                >
                  <FaLevelUpAlt />
                </button>
                <button
                  type="button"
                  className="btn btn-primary down"
                  onClick={() => handleMoveElement(editingIndex, "down")}
                  disabled={
                    editingIndex === null ||
                    editingIndex === emailContentData.length - 1
                  }
                >
                  <FaLevelDownAlt />
                </button>
              </div>
              <div className="input-group-wrap mb-3">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={() => handleSubmit("button")}
                >
                  {editingIndex !== null && editingType === "button"
                    ? editEmailTemp.updateButton
                    : editEmailTemp.addButton}
                </button>
              </div>
              {editingIndex !== null && (
                <div
                  className="input-group-wrap mb-3"
                  onClick={() => handleDeleteElement(editingIndex)}
                >
                  <button type="button" className="btn btn-secondary btn-block">
                    {editEmailTemp.deleteButton}
                  </button>
                </div>
              )}
            </div>
          )}

          {emailData.newElement === "link" && (
            <div className="mail-content">
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="linkURL">
                  <strong>{editEmailTemp.linkURL}</strong>
                </label>
                <input
                  type="text"
                  placeholder="Please enter link URL"
                  name="linkUrl"
                  value={emailData.linkUrl}
                  onChange={handleInputChange}
                />
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="linkText">
                  <strong>{editEmailTemp.linkText}</strong>
                </label>
                <input
                  type="text"
                  placeholder="Please enter link text"
                  name="linkText"
                  value={emailData.linkText}
                  onChange={handleInputChange}
                />
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="">
                  <strong>{editEmailTemp.textAlignment}</strong>
                </label>
                <select
                  name="textAlign"
                  id="textAlign"
                  value={emailData.textAlign}
                  onChange={handleInputChange}
                >
                  {editTextAlign?.map((item, index) => (
                    <option value={item.value} key={index}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group-wrap mb-3">
                <label className="mb-1" htmlFor="fontSize">
                  <strong>{editEmailTemp.fontSize}</strong>
                </label>
                <select
                  name="fontSize"
                  id="fontSize"
                  value={emailData.fontSize}
                  onChange={handleInputChange}
                >
                  {fontSize.map((data, index) => (
                    <option key={index} value={data.value}>
                      {data.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group-wrap mb-3 d-flex justify-content-between align-content-center">
                <button
                  type="button"
                  className="btn btn-primary up"
                  onClick={() => handleMoveElement(editingIndex, "up")}
                  disabled={editingIndex === null || editingIndex === 0}
                >
                  <FaLevelUpAlt />
                </button>
                <button
                  type="button"
                  className="btn btn-primary down"
                  onClick={() => handleMoveElement(editingIndex, "down")}
                  disabled={
                    editingIndex === null ||
                    editingIndex === emailContentData.length - 1
                  }
                >
                  <FaLevelDownAlt />
                </button>
              </div>
              <div className="input-group-wrap mb-3">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={() => handleSubmit("link")}
                >
                  {editingIndex !== null && editingType === "link"
                    ? editEmailTemp.updateLink
                    : editEmailTemp.addLink}
                </button>
              </div>

              {editingIndex !== null && (
                <div
                  className="input-group-wrap mb-3"
                  onClick={() => handleDeleteElement(editingIndex)}
                >
                  <button type="button" className="btn btn-secondary btn-block">
                    {editEmailTemp.deleteLink}
                  </button>
                </div>
              )}
            </div>
          )}

          {emailData.newElement === "hrLine" && (
            <div className="mail-content">
              <div className="input-group-wrap mb-3">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={() => handleSubmit("hrLine")}
                >
                  {editingIndex !== null && editingType === "hrLine"
                    ? editEmailTemp.updateLine
                    : editEmailTemp.addLine}
                </button>
              </div>

              <div className="input-group-wrap mb-3 d-flex justify-content-between align-content-center">
                <button
                  type="button"
                  className="btn btn-primary up"
                  onClick={() => handleMoveElement(editingIndex, "up")}
                  disabled={editingIndex === null || editingIndex === 0}
                >
                  <FaLevelUpAlt />
                </button>
                <button
                  type="button"
                  className="btn btn-primary down"
                  onClick={() => handleMoveElement(editingIndex, "down")}
                  disabled={
                    editingIndex === null ||
                    editingIndex === emailContentData.length - 1
                  }
                >
                  <FaLevelDownAlt />
                </button>
              </div>

              {editingIndex !== null && (
                <div
                  className="input-group-wrap mb-3"
                  onClick={() => handleDeleteElement(editingIndex)}
                >
                  <button type="button" className="btn btn-secondary btn-block">
                    {editEmailTemp.deleteLine}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="col-md-8 col-lg-9">
          <div className="preview-section mb-3">
            <div className="title-area border-bottom mb-3">
              <h2>{editEmailTemp.templatePreview}</h2>
            </div>
            <div className="preview-box">
              <table width="100%" cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th
                      style={{
                        padding: "25px 0",
                        margin: "0 auto",
                        textAlign: "center",
                        background: "#fff"
                      }}
                    >
                      <Link to="">
                        <img
                          src={Logo}
                          alt="FundTap"
                          style={{ maxWidth: "200px", width: "100%" }}
                        />
                      </Link>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      className="email-content-wrap"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                        borderTop: "1px solid #dee2e6",
                        width: "100%",
                        padding: "0",
                        margin: "0",
                        backgroundColor: "#ffffff"
                      }}
                    >
                      {emailContentData?.map(
                        (
                          {
                            id,
                            content,
                            style = {},
                            btnText,
                            btnUrl,
                            linkUrl,
                            linkText,
                            dataType,
                            btnType
                          },
                          index
                        ) => (
                          <React.Fragment key={index}>
                            {dataType === "paragraph" && (
                              <div
                                id={id}
                                style={{ ...style, padding: "7px 0" }}
                                onClick={() =>
                                  handleElementClick(
                                    id,
                                    content,
                                    style,
                                    "paragraph"
                                  )
                                }
                                className={
                                  editingIndex === index ? "selected-div" : ""
                                }
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: sanitizeInput(content)
                                  }}
                                />
                              </div>
                            )}

                            {dataType === "button" && (
                              <div
                                id={id}
                                style={{ ...style, padding: "7px 0" }}
                              >
                                <Link
                                  to={btnUrl || "#"}
                                  target="_blank"
                                  rel="noreferrer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleElementClick(
                                      id,
                                      content,
                                      style,
                                      "button",
                                      btnText,
                                      btnUrl
                                    );
                                  }}
                                  className={
                                    editingIndex === index ? "selected-div" : ""
                                  }
                                  style={{
                                    background: "var(--secondary-color)",
                                    color: "#ffffff",
                                    width: btnType === "Yes" ? "100%" : "",
                                    display:
                                      btnType === "Yes"
                                        ? "block"
                                        : "inline-block",
                                    padding: "6px 12px",
                                    textDecoration: "none"
                                  }}
                                >
                                  {btnText || ""}
                                </Link>
                              </div>
                            )}

                            {dataType === "link" && (
                              <div
                                id={id}
                                style={{
                                  ...style,
                                  padding: "7px 0",

                                  color: "var(--secondary-color)"
                                }}
                              >
                                <Link
                                  to={linkUrl || ""}
                                  target="_blank"
                                  rel="noreferrer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleElementClick(
                                      id,
                                      content,
                                      style,
                                      "button",
                                      linkText,
                                      linkUrl
                                    );
                                  }}
                                  className={
                                    editingIndex === index ? "selected-div" : ""
                                  }
                                  style={{
                                    textDecoration: "none",
                                    color: "var(--secondary-color)"
                                  }}
                                >
                                  {linkText || ""}
                                </Link>
                              </div>
                            )}

                            {dataType === "hrLine" && (
                              <div
                                id={id}
                                onClick={() => handleElementClick(index)}
                                className={
                                  editingIndex === index ? "selected-div" : ""
                                }
                                style={{
                                  ...style,
                                  borderTop: "1px solid #ccc",
                                  margin: "15px 0",
                                  padding: "7px 0"
                                }}
                              />
                            )}
                          </React.Fragment>
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        padding: "25px 0",
                        margin: "0 auto",
                        textAlign: "center"
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "Arial, Helvetica, sans-serif",
                          fontSize: "12px"
                        }}
                      >
                        © <span id="getYear" className="me-1" />
                        <Link
                          to=""
                          style={{
                            textDecoration: "none",
                            target: "_blank",
                            rel: "noreferrer",
                            color: "var(--secondary-color)"
                          }}
                        >
                          {editEmailTemp.fundTap}
                        </Link>
                        {editEmailTemp.allRightsReserved}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-12 mt-2">
          <div className="created-buttongroup">
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-secondary btn-red me-2"
            >
              {alertActions.Cancel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditMailTemplate;
